module.exports = __webpack_public_path__ + "img/frog.c6badb3b.png";